import { FC, useEffect } from 'react'
import { PageLoading } from '@/components/PageLoading'
// import authInstance from '@/utils/uc-auth-sdk/instance'
import { getUrlParam } from '@/utils'

export const Login: FC = () => {
  // const redirectUri = getUrlParam('redirectUri')
  useEffect(() => {
      if (process.env.REACT_APP_IDN_ENV === 'hw') {
          window.location.href = '/show-status'
          return
      }else{
        // authInstance.login({redirect: redirectUri? redirectUri : encodeURIComponent(location.origin),}, true)
      }
  }, [])

  return <PageLoading />
}